module.exports = __webpack_public_path__ + "static/media/i41img3.63f39935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/i41img3.jpg
// module id = 687
// module chunks = 0